import React from 'react';
import classNames from 'classnames';
import styles from './DMActionsTableHead.module.css';

function DMActionsTableHead({ className, style, children }) {
  return (
    <div className={classNames(styles.root, 'rt-thead', className)} style={style}>
      {children}
    </div>
  );
}

export default DMActionsTableHead;
